'use client';

import { useEffect } from 'react';
import NextTopLoader from 'nextjs-toploader';

const BAR_HEIGHT = 4;

/* Route-change progress bar anchored to the bottom edge of the fixed header,
   so it reads as a glowing underline beneath the navbar instead of hiding at
   the very top of the viewport. Tracks the navbar's shrink-on-scroll height
   via ResizeObserver; falls back to top of viewport if the header has no
   measurable height (e.g. Navbar v1 uses absolutely-positioned layers). */
export default function TopLoaderBar() {
  useEffect(() => {
    const header = document.querySelector('header');
    if (!header) return;
    const root = document.documentElement;
    const update = () => {
      const h = header.getBoundingClientRect().height;
      root.style.setProperty('--toploader-top', h > BAR_HEIGHT * 2 ? `${Math.round(h) - BAR_HEIGHT}px` : '0px');
    };
    update();
    const ro = new ResizeObserver(update);
    ro.observe(header);
    window.addEventListener('resize', update);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', update);
      root.style.removeProperty('--toploader-top');
    };
  }, []);

  return (
    <NextTopLoader
      color="#D4A96B"
      height={BAR_HEIGHT}
      showSpinner={false}
      shadow="0 0 10px rgba(212,169,107,0.75), 0 0 24px rgba(212,169,107,0.35)"
    />
  );
}
